import { render, staticRenderFns } from "./admin-uom-tab.vue?vue&type=template&id=55a8000e&scoped=true"
import script from "./admin-uom-tab.vue?vue&type=script&lang=ts"
export * from "./admin-uom-tab.vue?vue&type=script&lang=ts"
import style0 from "./admin-uom-tab.vue?vue&type=style&index=0&id=55a8000e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a8000e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55a8000e')) {
      api.createRecord('55a8000e', component.options)
    } else {
      api.reload('55a8000e', component.options)
    }
    module.hot.accept("./admin-uom-tab.vue?vue&type=template&id=55a8000e&scoped=true", function () {
      api.rerender('55a8000e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/data-management/tabs/admin-uom-tab.vue"
export default component.exports